/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetPaymentSubscriptionProfileQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetPaymentSubscriptionProfileQuery = {
  readonly __typename?: 'Query';
  readonly paymentSubscriptionProfile: {
    readonly __typename?: 'PaymentSubscriptionProfile';
    readonly id: string;
    readonly creditCards: ReadonlyArray<{
      readonly __typename?: 'SubscriptionCreditCard';
      readonly id: string;
      readonly cardType: Types.BraintreeCardType;
      readonly lastFour: string;
    }> | null;
  } | null;
};

export const GetPaymentSubscriptionProfileDocument = gql`
  query getPaymentSubscriptionProfile {
    paymentSubscriptionProfile {
      id
      creditCards {
        id
        cardType
        lastFour
      }
    }
  }
`;

export function useGetPaymentSubscriptionProfileQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetPaymentSubscriptionProfileQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetPaymentSubscriptionProfileQuery,
    GetPaymentSubscriptionProfileQueryVariables
  >({ query: GetPaymentSubscriptionProfileDocument, ...options });
}
